module.exports = __webpack_public_path__ + "static/media/Chicken_Pizza.5bafe205.jpg";